/*
  Repairs the thumbnail in the add-to-cart banner.

  Empire builds that thumbnail by rewriting the image's filename, matching it
  against a list of extensions that predates HEIC. A photo uploaded straight
  off a phone falls through, the helper hands back null, and the banner
  renders `<img src="null">`, which the browser draws as a broken image.

  Shopify's CDN resizes HEIC perfectly well through the `width` parameter, so
  the repair is to ask for the same thumbnail that way instead.

  This hangs off the image failing to load rather than off the add-to-cart
  event or the banner element, because Empire builds the banner from several
  places and puts up a second copy of it after the page has loaded. A failed
  load is the one signal that arrives whichever banner broke and whenever it
  was built.
*/
(function () {
  /* Twice the 100px the banner draws it at, so it stays sharp on retina. */
  var THUMBNAIL_WIDTH = 200;

  function repair(img) {
    /* The alt Empire has just written is the product title to look up by. */
    var title = img.getAttribute('alt');
    if (!title) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var line = cart.items.filter(function (item) {
          return item.product_title === title;
        })[0];

        if (!line || !line.image) return;

        var url = new URL(line.image, window.location.origin);
        url.searchParams.set('width', THUMBNAIL_WIDTH);
        img.src = url.toString();
      })
      .catch(function () {
        /* A broken thumbnail is where this started, so there is nothing to undo. */
      });
  }

  document.addEventListener(
    'error',
    function (event) {
      var img = event.target;
      if (!img || img.tagName !== 'IMG') return;
      if (!img.matches('[data-atc-banner-product-image] img')) return;

      /* Without this, a replacement that also fails would retry forever. */
      if (img.dataset.thumbnailRepaired) return;
      img.dataset.thumbnailRepaired = 'true';

      repair(img);
    },
    /* An image failing to load does not bubble, so catch it on the way down. */
    true
  );
})();
